import { NavLink, Route, Routes } from "react-router-dom";
import { Flex, Icon, IconName, Main, Paper, Span } from "@goodfill/ui-components";
import { PortfolioSection } from "./portfolio/PortfolioSection";
import { CorporateActionsSection } from "./corporateActions/CorporateActionsSection";
import { OrderListSection } from "./orderList/OrderListSection";
import { TradeHistorySection } from "./tradeHistory/TradeHistorySection";
import { DepositHistorySection } from "./depositHistory/DepositHistorySection";
import { PaymentHistorySection } from "./paymentHistory/PaymentHistorySection";
import { route } from "../../../routes";
import { TradeDetailSection } from "./tradeDetail/TradeDetailSection";
import { PortfolioPositionsSection } from "./positions/PortfolioPositionsSection";

const sectionKeys = [
  "portfolio",
  "orderList",
  "tradeHistory",
  "paymentHistory",
  "depositHistory",
  "corporateActions",
] as const;

type SectionKey = typeof sectionKeys[number];

interface Section {
  iconName: IconName;
  label: string;
  link: () => string;
}

type SectionRecord = Record<SectionKey, Section>;

const profileSections: SectionRecord = {
  portfolio: {
    iconName: "histogram",
    label: "Portfolio",
    link: route.portfolio,
  },
  orderList: {
    iconName: "copybook",
    label: "Order List",
    link: route.orderList,
  },
  tradeHistory: {
    iconName: "history",
    label: "Bond Trade History",
    link: route.tradeHistory,
  },
  paymentHistory: {
    iconName: "history",
    label: "Payment Receipt History",
    link: route.paymentHistory,
  },
  depositHistory: {
    iconName: "history",
    label: "Deposit/Withdrawal History",
    link: route.depositHistory,
  },
  corporateActions: {
    iconName: "briefcase",
    label: "Corporate Actions",
    link: route.corporateActions,
  },
};

export const PortfolioInfo: React.FC = () => {
  return (
    <Main>
      <Flex verticalMargin={8}>
        <Paper neutral={true}>
          <Flex direction="row" gap={4} verticalPadding={8}>
            <Flex direction="col" borderRight="medium" gap={8} horizontalPadding={8} verticalPadding={8}>
              {Object.entries(profileSections).map(([key, { iconName, label, link }]) => (
                <NavLink to={link()} key={key}>
                  {({ isActive }) => (
                    <Flex direction="row" items="center" gap={4}>
                      <Span primary={isActive}>
                        <Icon name={iconName} size={18} />
                      </Span>
                      <Span data-testid={key} font="medium" selectNone={true} primary={isActive}>
                        {label}
                      </Span>
                    </Flex>
                  )}
                </NavLink>
              ))}
            </Flex>

            <Routes>
              <Route path="portfolio" element={<PortfolioSection />} />
              <Route path="orderList" element={<OrderListSection />} />
              <Route path="corporateActions" element={<CorporateActionsSection />} />
              <Route path="tradeHistory" element={<TradeHistorySection />} />
              <Route path="paymentHistory" element={<PaymentHistorySection />} />
              <Route path="depositHistory" element={<DepositHistorySection />} />
              <Route path="positions/:bondId" element={<PortfolioPositionsSection />} />
              <Route path="tradeTicket/:tradeTicketId" element={<TradeDetailSection />} />
            </Routes>
          </Flex>
        </Paper>
      </Flex>
    </Main>
  );
};
